// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Container */
.app-header {
  background: var(--glass-bg-strong);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid var(--glass-border);
  padding: var(--space-lg) 0;
  margin-bottom: var(--space-xl);
  box-shadow: var(--shadow-md);
  animation: slideDown 0.4s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 var(--space-lg);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-lg);
}

/* Header Title */
.header-title {
  flex: 1 1;
  text-align: center;
}

.header-logo {
  font-size: var(--font-size-4xl);
  margin-bottom: var(--space-sm);
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {

  0%,
  100% {
    filter: brightness(1);
  }

  50% {
    filter: brightness(1.2);
  }
}

.header-subtitle {
  font-size: var(--font-size-lg);
  opacity: 0.9;
  margin: 0;
  color: var(--color-white);
}

/* User Section */
.header-user-section {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  min-width: fit-content;
}

.header-welcome {
  font-size: var(--font-size-sm);
  color: var(--color-white);
  white-space: nowrap;
}

.header-welcome strong {
  color: var(--color-accent-light);
  font-weight: var(--font-weight-bold);
}

/* Subscription Badge */
.subscription-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--space-sm);
  font-size: var(--font-size-lg);
  animation: crownShine 2s ease-in-out infinite;
  filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.6));
  cursor: help;
}

@keyframes crownShine {

  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.6));
  }

  50% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.9));
  }
}

.subscription-unclaimed-dot {
  position: absolute;
  top: -2px;
  right: -4px;
  width: 10px;
  height: 10px;
  background: var(--color-danger, #ef4444);
  border-radius: 50%;
  border: 2px solid var(--color-dark, #1a1a2e);
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.6);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

/* Donation Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--z-modal-backdrop);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 0;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.donate-modal {
  width: 550px;
  max-width: 90vw;
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 28px;
  color: white;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 1;
  font-weight: 300;
  line-height: 1;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: white;
  transform: rotate(90deg) scale(1.1);
}

@media (prefers-color-scheme: dark) {
  .modal-content {
    background: #2a2a2a;
  }

  .donate-modal {
    background: transparent;
  }

  .modal-close {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    color: white;
  }

  .modal-close:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: white;
  }
}

/* Date Generation Counter in Header */
.header-date-gens {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.85rem;
  white-space: nowrap;
}

.date-gen-label {
  color: rgba(255, 255, 255, 0.9);
  cursor: default;
}

.date-gen-bonus {
  color: #a855f7;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header.css"],"names":[],"mappings":"AAEA,qBAAqB;AACrB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,2CAA2C;EAC3C,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,6CAA6C;EAC7C,mDAAmD;EACnD,YAAY;AACd;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,mDAAmD;EACrD;;EAEA;IACE,qBAAqB;IACrB,mDAAmD;EACrD;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["@import '../../styles/variables.css';\n\n/* Header Container */\n.app-header {\n  background: var(--glass-bg-strong);\n  backdrop-filter: blur(15px);\n  border-bottom: 1px solid var(--glass-border);\n  padding: var(--space-lg) 0;\n  margin-bottom: var(--space-xl);\n  box-shadow: var(--shadow-md);\n  animation: slideDown 0.4s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.header-content {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0 var(--space-lg);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-lg);\n}\n\n/* Header Title */\n.header-title {\n  flex: 1;\n  text-align: center;\n}\n\n.header-logo {\n  font-size: var(--font-size-4xl);\n  margin-bottom: var(--space-sm);\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);\n  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: shimmer 3s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n\n  0%,\n  100% {\n    filter: brightness(1);\n  }\n\n  50% {\n    filter: brightness(1.2);\n  }\n}\n\n.header-subtitle {\n  font-size: var(--font-size-lg);\n  opacity: 0.9;\n  margin: 0;\n  color: var(--color-white);\n}\n\n/* User Section */\n.header-user-section {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  min-width: fit-content;\n}\n\n.header-welcome {\n  font-size: var(--font-size-sm);\n  color: var(--color-white);\n  white-space: nowrap;\n}\n\n.header-welcome strong {\n  color: var(--color-accent-light);\n  font-weight: var(--font-weight-bold);\n}\n\n/* Subscription Badge */\n.subscription-badge {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--space-sm);\n  font-size: var(--font-size-lg);\n  animation: crownShine 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.6));\n  cursor: help;\n}\n\n@keyframes crownShine {\n\n  0%,\n  100% {\n    transform: scale(1);\n    filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.6));\n  }\n\n  50% {\n    transform: scale(1.1);\n    filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.9));\n  }\n}\n\n.subscription-unclaimed-dot {\n  position: absolute;\n  top: -2px;\n  right: -4px;\n  width: 10px;\n  height: 10px;\n  background: var(--color-danger, #ef4444);\n  border-radius: 50%;\n  border: 2px solid var(--color-dark, #1a1a2e);\n  box-shadow: 0 0 8px rgba(239, 68, 68, 0.6);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n}\n\n/* Donation Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: var(--z-modal-backdrop);\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-content {\n  position: relative;\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.donate-modal {\n  width: 550px;\n  max-width: 90vw;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.modal-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  font-size: 28px;\n  color: white;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  z-index: 1;\n  font-weight: 300;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: white;\n  transform: rotate(90deg) scale(1.1);\n}\n\n@media (prefers-color-scheme: dark) {\n  .modal-content {\n    background: #2a2a2a;\n  }\n\n  .donate-modal {\n    background: transparent;\n  }\n\n  .modal-close {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.3);\n    color: white;\n  }\n\n  .modal-close:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: white;\n  }\n}\n\n/* Date Generation Counter in Header */\n.header-date-gens {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 0.85rem;\n  white-space: nowrap;\n}\n\n.date-gen-label {\n  color: rgba(255, 255, 255, 0.9);\n  cursor: default;\n}\n\n.date-gen-bonus {\n  color: #a855f7;\n  font-weight: 600;\n  font-size: 0.8rem;\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
